<template>
  <sp-button
    tag="a"
    icon="play-filled"
    color="primary"
    class="sp-finder-result-video"
    part="base"
    densitysmcompact="false"
    :href="videoUrl"
    :aria-label="label"
    @click="handlePlay"
  ></sp-button>
</template>

<script setup>
import { computed } from "vue";
import { i18n } from "#ce/components/SpFinder/i18n";

const props = defineProps({
  /**
   * The provider's display name, for the button's accessible name and the video header.
   *
   * @type {String}
   */
  name: {
    type: String,
    default: "",
  },
  /**
   * The provider's profile URL, shown in the video header.
   *
   * @type {String}
   */
  url: {
    type: String,
    default: "",
  },
  /**
   * The video to play.
   *
   * @type {String}
   */
  videoUrl: {
    type: String,
    required: true,
  },
});

const label = computed(() => i18n.global.t("video_label", { name: props.name }));

const emit = defineEmits(["play-video"]);

function handlePlay(event) {
  event.preventDefault();
  emit("play-video", { name: props.name, url: props.url, videoUrl: props.videoUrl });
}
</script>

<style>
:host {
  display: block;
}
</style>

<style lang="scss" scoped>
// The play glyph fills 81% of the button and sits 4% right of centre, so it reads as optically centred.
.sp-finder-result-video {
  --sp-comp-button-size: 100%;
  --sp-comp-button-padding: 0;
  --sp-comp-button-icon-size: 81cqmin;
  --sp-comp-icon-transform: translateX(4%);

  container-type: size;
  display: block;
  width: 100%;
  height: 100%;
}
</style>
